module.exports = __webpack_public_path__ + "frontend-assets/img/Easter_animation_small_CLEAN.0ed1bea6.gif";